import React, { useContext } from 'react';
import { AdfDefaultTheme } from './AdfDefaultTheme';
import { AdfDoc } from './AdfModelTypes';
import { AdfNode } from './AdfNode';

interface AdfDocumentProps {
    doc: AdfDoc;
    jiraIssueId?: string;
}

export const useAdfDocumentContext = () => {
    return useContext(AdfDocumentContext);
};

export const AdfDocumentContext = React.createContext<AdfDocumentProps>(null);

export const AdfViewer = React.memo(({ doc, jiraIssueId }: AdfDocumentProps) => {
    if (!doc) return null;
    return <AdfDocumentContext.Provider value={{ doc, jiraIssueId }}>
        <AdfDefaultTheme>
            {doc?.content?.map((node, i) => <AdfNode key={i} node={node} />)}
        </AdfDefaultTheme>
    </AdfDocumentContext.Provider>;
});
